import { render, staticRenderFns } from "./alertPass.vue?vue&type=template&id=fbdacc04&scoped=true"
import script from "./alertPass.vue?vue&type=script&lang=js"
export * from "./alertPass.vue?vue&type=script&lang=js"
import style0 from "./alertPass.vue?vue&type=style&index=0&id=fbdacc04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdacc04",
  null
  
)

export default component.exports